import type { IconData } from '@stacksjs/iconify-core'

export const locationHeartPinFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M4.5 21C4.5 10.23 13.23 1.5 24 1.5S43.5 10.23 43.5 21c0 6.987-3.606 12.865-7.526 17.203c-3.932 4.351-8.326 7.316-10.237 8.506a3.26 3.26 0 0 1-3.474 0c-1.91-1.19-6.305-4.155-10.237-8.506C8.106 33.865 4.5 27.987 4.5 21\"/><path fill=\"#2859c5\" d=\"M13.698 18.332c.992-4.519 6.48-6.39 9.919-3.338c.132.116.26.245.383.373a7 7 0 0 1 .384-.373c3.439-3.051 8.928-1.18 9.92 3.338c.654 2.813-.378 5.25-1.99 7.289c-1.605 2.03-3.83 3.725-5.672 5.083a4.46 4.46 0 0 1-5.283 0c-1.842-1.358-4.067-3.052-5.672-5.083c-1.612-2.04-2.644-4.476-1.99-7.289Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationHeartPinFlat
